<template>
  <v-dialog v-model="openMode" max-width="650px" content-class="context-details-dialog" scrollable>
    <v-card class="dialog-card">
      <v-card-title class="dialog-header">
        <h2 class="dialog-title">Call Details</h2>
        <v-spacer></v-spacer>
        <v-btn icon @click="closeDelete">
          <v-icon>mdi-close</v-icon>
        </v-btn>
      </v-card-title>

      <v-divider></v-divider>

      <v-card-text class="dialog-content">
        <v-data-table :headers="headers" :items="callDetailCloned" sort-by="start" sort-desc :footer-props="{
          'items-per-page-options': [10, 25, 50, 100],
          'items-per-page-text': 'Rows per page:'
        }" :mobile-breakpoint="0" class="call-details-table" :loading="progressShow" loading-text="Loading data..."
          no-data-text="No extension entries found">
          <template v-for="header in headers"
            v-slot:[`header.${header.value}`]="{ header }">
            <span class="header-text">{{ header.text }}</span>
          </template>

          <template v-slot:item="{ item, index }">
            <tr class="table-row">
              <td class="text-center">{{ index + 1 }}</td>
              <td class="text-center">
                <div class="date-cell">
                  <div class="date-primary">{{ formatDatePrimary(item.date_enter) }}</div>
                  <div class="date-secondary">{{ formatDateSecondary(item.date_enter) }}</div>
                </div>
              </td>
              <td class="text-center">
                <v-chip small outlined color="#0d2c6d" class="context-chip">
                  {{ item.context === "welcome" ? "Welcome" : item.context === "main" ? "Main" : item.context === "Ad" ? "Ad" : item.context === "welcome-after-Ad" ? "Welcome after Ad" :
                  item.context.includes("main") ? item.context.replace("main", "Main")  : item.context }}
                </v-chip>
              </td>
              <td class="text-center">
                <div class="duration-wrapper">
                  <v-icon small color="#0d2c6d" class="mr-1">mdi-clock-outline</v-icon>
                  <span class="duration-text">{{ item.duration }}</span>
                </div>
              </td>
            </tr>
          </template>

          <template v-slot:progress>
            <v-progress-linear color="#0d2c6d" indeterminate absolute height="2"></v-progress-linear>
          </template>

          <template v-slot:no-data>
            <div class="empty-state">
              <v-icon size="64" color="grey lighten-1">mdi-phone-off</v-icon>
              <p class="empty-text">No extension entries found</p>
            </div>
          </template>
        </v-data-table>
      </v-card-text>

      <v-divider></v-divider>

      <v-card-actions class="dialog-actions">
        <v-spacer></v-spacer>
        <v-btn color="#0d2c6d" text @click="closeDelete">
          Close
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import moment from "moment-timezone";

export default {
  props: {
    callDetails: Array,
    value: { type: Boolean, default: false },
  },
  data: () => ({
    callDetailCloned: [],
    progressShow: false,
    headers: [
      { text: '#', value: "index", sortable: false, width: '5%' },
      { text: 'Date', align: 'center', value: 'date_enter', width: '35%' },
      { text: 'Entered Extension', value: 'context', align: 'center', width: '30%' },
      { text: 'Duration in Extension', value: 'duration', align: 'center', width: '30%' },
    ],
  }),
  methods: {
    closeDelete() {
      this.openMode = false;
    },

    formatDetails() {
      this.callDetailCloned = this.callDetailCloned.map((call) => {
        return {
          ...call,
          duration: this.formatDuration(call.duration),
          date_enter: moment
            .tz(call.date_enter, 'YYYY-MM-DD HH:mm:ss', 'Asia/Jerusalem')
            .tz(this.$store.state.timezone)
            .format('DD/MM/YYYY, HH:mm:ss')
        }
      });
    },

    formatDuration(seconds) {
      const hours = Math.floor(seconds / 3600);
      const minutes = Math.floor((seconds % 3600) / 60);
      const sec = seconds % 60;

      const paddedHours = hours.toString().padStart(2, '0');
      const paddedMinutes = minutes.toString().padStart(2, '0');
      const paddedSeconds = sec.toString().padStart(2, '0');

      return `${paddedHours}:${paddedMinutes}:${paddedSeconds}`;
    },

    formatDatePrimary(dateString) {
      // Extract just the date part (DD/MM/YYYY)
      return dateString.split(',')[0];
    },

    formatDateSecondary(dateString) {
      // Extract just the time part (HH:mm:ss)
      return dateString.split(',')[1].trim();
    }
  },
  computed: {
    openMode: {
      get() {
        return this.value;
      },
      set(v) {
        return this.$emit('input', v);
      }
    },
  },
  created() {
    this.progressShow = true;
    this.callDetailCloned = [...this.callDetails];
    this.formatDetails();
    this.progressShow = false;
  },
}
</script>

<style scoped>
.context-details-dialog {
  border-radius: 8px;
  overflow: hidden;
}

.dialog-card {
  border-radius: 8px;
  overflow: hidden;
  display: flex;
  flex-direction: column;
}

.dialog-header {
  background-color: #f5f7fa;
  padding: 16px 24px;
  display: flex;
  align-items: center;
}

.dialog-title {
  color: #0d2c6d;
  font-size: 1.25rem;
  font-weight: 600;
  margin: 0;
  font-family: 'Heebo', sans-serif;
}

.dialog-content {
  padding: 0;
  flex: 1;
}

.dialog-actions {
  padding: 12px 24px;
  background-color: #f5f7fa;
}

.call-details-table {
  width: 100%;
  border-radius: 0;
}

/* Style for table headers */
.call-details-table>>>th {
  background-color: #f5f7fa !important;
  height: 48px !important;
  text-align: center !important;
  font-family: 'Heebo', sans-serif !important;
  font-size: 14px;
  font-weight: 600 !important;
  color: #0d2c6d;
  border-bottom: 1px solid rgba(0, 0, 0, 0.12) !important;
}

.header-text {
  font-weight: 600;
}

.table-row {
  height: 60px !important;
  transition: background-color 0.2s;
}

.table-row:hover {
  background-color: #f8f9fd !important;
}

/* Alternating row colors */
.call-details-table>>>tbody tr:nth-child(even) {
  background-color: rgba(0, 0, 0, 0.03);
}

.date-cell {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
}

.date-primary {
  font-weight: 500;
  color: #333;
  font-size: 14px;
}

.date-secondary {
  color: #666;
  font-size: 12px;
  margin-top: 2px;
}

.context-chip {
  font-family: 'Heebo', sans-serif !important;
  font-size: 13px !important;
}

.duration-wrapper {
  display: flex;
  align-items: center;
  justify-content: center;
}

.duration-text {
  font-family: 'Heebo', sans-serif !important;
  font-size: 14px !important;
  color: #333;
}

.empty-state {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 48px 0;
}

.empty-text {
  margin-top: 16px;
  font-size: 16px;
  color: #666;
  font-family: 'Heebo', sans-serif;
}

/* Custom scrollbar */
::-webkit-scrollbar {
  width: 8px;
  height: 8px;
}

::-webkit-scrollbar-track {
  background: #f1f1f1;
  border-radius: 4px;
}

::-webkit-scrollbar-thumb {
  background: #0d2c6d;
  border-radius: 4px;
}

::-webkit-scrollbar-thumb:hover {
  background: #183677;
}
</style>